import { createContext, ReactNode, PropsWithChildren, useContext } from 'react';

export type FileExplorerContextProps<TData> = {
  onRowClick?: (row: TData) => void;
  isRowClickable?: (row: TData) => boolean;
  getRowId?: (row: TData) => ReactNode;
  getRowName?: (row: TData) => ReactNode;
  getRowTypeIcon?: (row: TData) => ReactNode;
  rowIdKey: keyof TData;
  rowNameKey: keyof TData;
  rowTypeKey: keyof TData;
};

export const FileExplorerContext = createContext({});

export const useFileExplorerContext = <TData,>() =>
  useContext(FileExplorerContext) as FileExplorerContextProps<TData>;

export function FileExplorerContextProvider<TData>({
  children,
  ...props
}: PropsWithChildren<FileExplorerContextProps<TData>>) {
  return (
    <FileExplorerContext.Provider value={props}>
      {children}
    </FileExplorerContext.Provider>
  );
}
